import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import _ from 'lodash'

// ------------------------------------
// Constants
// ------------------------------------
export const KYC_REFERRAL = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    QUERY_INVITE_LIST_REQUEST: null,
    QUERY_INVITE_LIST_SUCCESS: null,
    SHOW_PAGE: null
  },
  'KYC_REFERRAL'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/national-day/v1/auth/inviter-activity/detail',
        method: 'POST',
        requestAction: KYC_REFERRAL.INIT_REQUEST,
        successAction: KYC_REFERRAL.INIT_SUCCESS,
        success: function(result) {
          const { bizData = {} } = result.commandData
          const status = _.get(bizData, 'status')
          if (status === 'Y') {
            const activityCode = _.chain(bizData)
              .get('inviterActivity.activityCode')
              .value()
            dispatch(
              queryInviteList({
                activityCode
              })
            )
          }
        }
      })
    )
  }
}

export function queryInviteList(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/event/national-day/v1/auth/inviter-activity/list',
        method: 'POST',
        body: {
          ...data,
          pageNum: 1,
          pageSize: 20
        },
        requestAction: KYC_REFERRAL.QUERY_INVITE_LIST_REQUEST,
        successAction: KYC_REFERRAL.QUERY_INVITE_LIST_SUCCESS,
        success: function(result) {}
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [KYC_REFERRAL.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [KYC_REFERRAL.INIT_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    return Object.assign({}, state, action.payload, { ...commandData })
  },
  [KYC_REFERRAL.QUERY_INVITE_LIST_REQUEST]: (state, action) => state,
  [KYC_REFERRAL.QUERY_INVITE_LIST_SUCCESS]: (state, action) => {
    const { commandData = {} } = action.payload
    return Object.assign({}, state, { ...commandData.bizData })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'kycReferral',
    reducerMap: {
      kycReferralState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
